// Yet another `fold (.)`, but named for a particular use case.

export const applyMixins = (...args) => {
  // Only reverse once, since this is a mutable array.
  const mixins = args.reverse();
  return (inner) => mixins.reduce((component, mixin) => mixin(component), inner);
};
